import Snappy from '../../../libs/snappy/snappy';
import Form from '../../../libs/validation/customValidation.js';
import $ from 'jquery';

Snappy.Component.FindFootball = class FindFootball extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-find-football';
	}
	
	constructor(element) {
		super(element);
	}
	
	setVars() {
		this.findFootballForm = document.getElementById('findFootballForm');
		this.findFootballLocation = document.getElementById('find-football-location');
		this.findFootballType = document.getElementById('find-football-type');
		this.findFootballGenfer = document.getElementById('find-football-gender');
		this.findFootballAge = document.getElementById('find-football-age');
	}
	
	render() {
		this.setVars();
		this.addEventListeners();
		this.attachValidationToForm();
	}

    addEventListeners() {
        this.findFootballForm.addEventListener('submit', this.onSubmit.bind(this));
    }

	attachValidationToForm() {
		this.formInstance = new Form(this.findFootballForm);
		this.formInstance.init();
	}

    onSubmit() {
        if ($('body').hasClass('cfa-generic')) {
            this.trackSubmit();
        }
	}

    trackSubmit() {
        if ($(this.findFootballForm).valid()) {
        	let label = this.findFootballLocation.value +
				' > ' + this.findFootballType.options[this.findFootballType.selectedIndex].innerHTML +
				' > ' + this.findFootballGenfer.options[this.findFootballGenfer.selectedIndex].innerHTML +
				' > ' + this.findFootballAge.options[this.findFootballAge.selectedIndex].innerHTML;
            $(window).trigger('gtm:send', [ 'Find Football Near You', 'Search', label]);
		}
	}
};



// WEBPACK FOOTER //
// ./components/findFootball/scripts/findFootball.js